/*
 * @Author: tanyaohua
 * @Date: 2021-10-27 17:51:13
 * @LastEditTime: 2021-10-27 17:51:55
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\trill\trill.js
 * @Description: 
 */
/**
 * Created by cc 19-10-28
 * 抖音渠道后台管理功能
 */
'use strict';
angular.module('productManageMentTrillModule', ['productManageMentTrillServiceModule']).controller('productManageMentTrillCtrl', ['$scope', '$controller', 'editingMediatype',
    function($scope, $controller, editingMediatype) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.searchParams = {
                'serviceid': 'mlf_douyinconfig',
                'methodname': 'query',
                'douYinAccountName': '',
                'PageSize': 100,
                'CurrPage': 1,
            };
            $scope.accountKey = 'ACCOUNTID';
            $scope.mediaAccountKey = 'DOUYINACCOUNTID';
            $scope.rightsKey = 'douyinset.account';
            $scope.mediaName = '抖音';
            $scope.mediaType = 'trill';
            $scope.mediaTypeId = editingMediatype[$scope.mediaType]; // 渠道id
            $scope.rightsParams = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperKeyOfDouYin',
                Classify: $scope.rightsKey
            };
            $scope.newAccountParams = {
                serviceid: 'mlf_douyinconfig',
                methodName: 'saveDouYinAccount',
                douYinAccountName: '',
                'is_original': 0,
            };
            $scope.reAuthorizeParams = {
                serviceid: 'mlf_douyinconfig',
                methodName: 'reAuthorize',
            };
            $scope.deleteAccountParams = {
                serviceid: 'mlf_douyinconfig',
                methodname: 'deleteDouYinAccounts'
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            // 合并抖音控制器，实现复用
            $controller('productManageMentShortVideoCtrl', { $scope: $scope });
        }
    },
]);
